import TYPES from './types';
import { getTotal } from '../../../api/appointment';

export const getAppointmentsTotal = () =>
  getTotal()
    .then(response => ({
      type: TYPES.trialControl,
      payload: response.data,
    }))
    .catch(() => { })
